export default {"src":"/cbr/_next/static/media/aichat-logo-dark.fe0940ac.svg","height":108,"width":280,"blurWidth":0,"blurHeight":0};